// extracted by mini-css-extract-plugin
module.exports = {"position":"notifications_position__4Flhr","activeClass":"notifications_activeClass__1hiPb"};